import { render, staticRenderFns } from "./ProcessoMigradoEditar.vue?vue&type=template&id=4ca9faae&"
import script from "./ProcessoMigradoEditar.vue?vue&type=script&lang=js&"
export * from "./ProcessoMigradoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports